import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { isError } from "@nju/result";
import { ICheckPaymentResult } from "./types";
import { serverResponse } from "./validators";

interface IParams {
  paymentId: string;
}

export async function checkPayment({
  paymentId,
}: IParams): Promise<ICheckPaymentResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/payment/${paymentId}`,
    {
      validator: serverResponse,
    },
  );

  if (isError(result)) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
